<template>
    <div class="row scrollable events bg-white">
        <div class="col-12 mb-3 mt-3">
            <h3>{{ $t('pages.admin.Users') }}</h3>
        </div>
        <div class="col-8">
            <input class="form-control" :placeholder="$t('fields.Search')" v-model="filter" @input="($event) => { filter = $event.target.value; filterResults()}">
        </div>
        <div class="col-4 text-right">

        </div>
        <div class="col mt-4">
            <loading :name="loaderName" >
                <table class="table table-striped table-sm table-borderless">
                    <thead>
                    <th>{{$t('fields.FirstName')}}</th>
                    <th>{{$t('fields.LastName')}}</th>
                    <th>{{$t('fields.BirthDate')}}</th>
                    <th>{{$t('fields.City')}}</th>
                    <th>{{$t('fields.Email')}}</th>
                    <th>{{$t('fields.PhoneNumber')}}</th>
                    <th>{{$t('fields.IsAdmin')}}</th>
                    <th>{{$t('fields.IsEditor')}}</th>
                    <th>{{$t('fields.ParticipantCount')}}</th>
                    <th>{{$t('fields.VolunteerCount')}}</th>
                    <th>{{$t('fields.AdminUserNote')}}</th>
                    <th>{{$t('fields.Actions')}}</th>
                    </thead>
                    <tbody v-if="list && list.data">
                    <tr v-for="user in list.data" :key="'user-'+user.email">
                        <td>{{user.first_name}}</td>
                        <td>{{user.last_name}}</td>
                        <td>{{user.birth_date | formatTime('MMM YYYY')}}</td>
                        <td>{{user.city}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.phone}}</td>
                        <td>{{user.is_admin == 1 ? 'Ano' : 'Nie'}}</td>
                        <td>{{user.is_writer == 1? 'Ano' : 'Nie'}}</td>
                        <td>{{user.participant_count}}</td>
                        <td>{{user.volunteer_count}}</td>
                        <td>{{user.admin_note}}</td>
                        <td>
                            <reset-password-modal class="mr-1" :first-name="user.first_name" :last-name="user.last_name"
                                                  :user-id="user.id"></reset-password-modal>
                            <router-link :to="'/admin/users/' + user.id" class="fas fa-pencil-alt hand primary-color col-6"
                                         :title="$t('button.Edit')"></router-link>
                        </td>
                    </tr>
                    </tbody>
                    <tr v-else class="text-center">
                        <td colspan="11">{{$t('errorMessages.NO_DATA')}}</td>
                    </tr>
                </table>
                <paginate
                        v-if="list && list.last_page"
                        v-model="page"
                        :page-count="list.last_page"
                        :click-handler="changePage"
                        :prev-text="$t('button.Prev')"
                        :next-text="$t('button.Next')"
                        :page-class="'page-item'"
                        :container-class="'pagination justify-content-center'">
                </paginate>
            </loading>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {ROUTER_NAMES} from '../../constants';
    import paginationMixin from '../../mixins/paginationMixin';
    import filterMixin from '../../mixins/filterMixin';
    import ResetPasswordModal from '../../components/user/ResetPasswordModal';

    export default {
        name: 'Events',
        components: {ResetPasswordModal},
        mixins: [paginationMixin, filterMixin],
        created() {
            this.$wait.start(this.loaderName);
            this.filters = [{
                name: 'p',
                type: 'string',
            }, {
                name: 'filter',
                type: 'string'
            }];
            this.resolveFilters();
            this.loadContent()
                .then(() => {
                    this.$wait.end(this.loaderName);
                })
                .catch(e => {
                    this.$router.push({
                        name: ROUTER_NAMES.ERROR
                    });
                });
        },
        data() {
            return {
                filter: '',
                filters: [],
                routeName: ROUTER_NAMES.ADMIN_USERS,
                loaderName: 'load users',
                clearAction: 'clearUsers'
            };
        },
        methods: {
            ...mapActions(['loadUsers']),
            loadContent(page) {
                return this.loadUsers({
                    page: page || this.page,
                    filter: this.filter
                });
            },
        },
        computed: {
            items() {
                return this.$store.state.admin.users;
            }
        }
    };
</script>

<style scoped>
</style>
